import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import ReferralCard from "../../ReferralCard";
import styles from "../styles.module.scss";
const ReferralTab = () => {
    const referralData = useSelector((state) => state.referalInfo.referalInfo);
    const getCTA = (data, index) => {
        if (data.loaded && index == 0) {
            return "Applied for next order";
        }
        return "Apply 40% off next order";
    };
    const getIsClickable = (data, index) => {
        if (!data.loaded && index == 0) {
            return true;
        }
        return false;
    };
    const getColor = (data, index) => {
        if (data.loaded && index == 0) {
            return "dark";
        }
        else if (!data.loaded) {
            return "light";
        }
        return "grey";
    };
    return (_jsxs("div", { children: [referralData.stored?.length === 0 &&
                _jsx("p", { className: styles.empty, children: "You don't have any referral credit" }), referralData.stored?.map((data, index) => (_jsx("div", { children: _jsx(ReferralCard, { name: data.name, clickable: getIsClickable(data, index), cta: getCTA(data, index), color: getColor(data, index) }) }, index)))] }));
};
export default ReferralTab;
